/* global fbq */

import loadsSearchTypes from '~/modules/loadsSearch/types';

const fbLogger = (/* store */) => nextDispatch => action => {
  nextDispatch(action);

  if (action.type !== loadsSearchTypes.LOADS_SEARCH || !action.pending) {
    return;
  }
  try {
    fbq('track', 'Search');
  } catch (FBQError) {
    console.error(FBQError)
  }
};

export default fbLogger;



// WEBPACK FOOTER //
// ./src/middlewares/fb.js